<button mat-icon-button (click)="startVideoChat()" *ngIf="isInVideoChat()" class="animated jackInTheBox slow infinite">
    <mat-icon class="red-icon">video_call</mat-icon>
</button>